<template>
  <div id="app">
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  mounted(){
    this.$store.dispatch('getTypeDataConfig')
  }
}
</script>

<style lang="scss">
  #app{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
  .noData{
    text-align: center;
    margin: 50px auto;
    color: #aaaaaa;
    font-size: 14px;
  }
  .list-container {
    max-width: 800px;
    margin: 0 auto;
    background: white;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    overflow: hidden;
  }

  .list-item {
    display: flex;
    align-items: center;
    padding: 8px;
    border-bottom: 1px solid #eee;
    transition: background 0.3s;
  }

  .list-item:hover {
    background-color: #f9f9f9;
  }

  .item-image {
    width: 70px;
    height: 70px;
    border-radius: 8px;
    margin-right: 8px;
    flex-shrink: 0;
    box-shadow: 0px 0px 5px #e2e2e2;
  }

  .item-content {
    flex-grow: 1;
    margin-right: 20px;
  }

  .item-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
    color: #333;
  }

  .item-desc {
    font-size: 12px;
    color: #666;
    margin-bottom: 5px;
    line-height: 1.2;
  }

  .item-meta {
    font-size: 12px;
    color: #999;
  }

  .item-button {
    padding: 6px 12px;
    background-color: #4285f4;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background 0.3s;
    flex-shrink: 0;
  }

  .item-button:hover {
    background-color: #3367d6;
  }
  .servicesWrap{
    .servicesHeader img{
      width: 100%;
    }
    padding-bottom: 100px;
  }
  .servicesTitle{
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;
    padding-left: 20px;
  }



  .profile-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    background: linear-gradient(to bottom, #e6ebf2, #a5c2f6);
    padding: 16px;
    max-width: 320px;
    margin: 10px auto 25px;
  }
  .profile-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 12px;
    flex-shrink: 0;
  }
  .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .user-info h2 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  .user-info p {
    font-size: 14px;
    color: #666;
  }
  .stats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
  }
  .stat-item {
    text-align: center;
    padding: 8px;
  }
  .stat-value {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  .stat-label {
    font-size: 12px;
    color: #888;
  }
</style>
